import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import IntlComponent from 'axway-react-intl';
import { ModalDialog } from 'axway-react-ui';
import JoinInfoDialogContent from './JoinInfoDialogContent';

class JoinInfoDialog extends React.Component {
	constructor(props) {
		super(props);
		IntlComponent.init(this);
		this.onChange = this.onChange.bind(this);
		this.onOkay = this.onOkay.bind(this);

		// Don't want the change handler to trigger renders
		// so have to store the updated values locally rather
		// than in state.
		this.values = {
			parentModel: '',
			parentField: '',
			joinType: '',
			joinModel: '',
			joinField: '',
			joinAs: '',
			joinAsFieldName: ''
		};
	}

	componentWillMount() {
		this.initializeValues(this.props);
	}

	componentWillReceiveProps(props) {
		this.initializeValues(props);
	}

	onChange(data) {
		this.values = {
			...this.values,
			...data
		};
	}

	onOkay() {
		this.props.onOkay(this.values);
	}

	/**
	 * Save the property values.
	 */
	initializeValues(props) {
		this.values = {
			parentModel: props.parentModel,
			parentField: props.parentField,
			joinType: props.joinType,
			joinModel: props.joinModel,
			joinField: props.joinField,
			joinAs: props.joinAs,
			joinAsFieldName: props.joinAsFieldName
		};
	}

	/**
	 * The title for the dialog, based on the mode the dialog was opened in.
	 */
	getTitle() {
		if (this.props.parentField) {
			return this.intl.formatMsg('Edit a join');
		} else {
			return this.intl.formatMsg('Create a join');
		}
	}

	render() {
		return (
			<ModalDialog
				title={this.getTitle()}
				okayText={this.props.okayText || this.intl.formatMsg('Join')}
				closeText={this.props.closeText || this.intl.formatMsg('Cancel')}
				onClose={this.props.onClose}
				onOkay={this.onOkay}
				show
			>
				<JoinInfoDialogContent
					models={this.props.models}
					fields={this.props.fields}
					availableJoinTypes={this.props.availableJoinTypes}

					parentModel={this.props.parentModel}
					parentField={this.props.parentField}

					joinType={this.props.joinType}
					joinModel={this.props.joinModel}
					joinField={this.props.joinField}

					joinAs={this.props.joinAs}
					joinAsFieldName={this.props.joinAsFieldName}
					onChange={this.onChange}
					onSubmit={this.onOkay}
				/>
			</ModalDialog>
		);
	}
}

JoinInfoDialog.propTypes = {
	/**
	 * Models available for selection
	 */
	models: PropTypes.object.isRequired,

	/**
	 * A list of field names in the composite model.
	 */
	fields: PropTypes.array,

	/**
	 * The possible joins available on this model
	 */
	availableJoinTypes: PropTypes.array,

	/**
	 * The parent model on which the join will be performed
	 */
	parentModel: PropTypes.string.isRequired,

	/**
	 * The parent model's field on which the join will be performed
	 */
	parentField: PropTypes.string,

	/**
	 * The pre-selected model name
	 */
	joinModel: PropTypes.string,

	/**
	 * The pre-selected model field
	 */
	joinField: PropTypes.string,

	/**
	 * The pre-selected join type (left_join/inner_join)
	 */
	joinType: PropTypes.string,

	/**
	 * The pre-selected merge type (object/array/fields)
	 */
	joinAs: PropTypes.string,

	/**
	 * The pre-specified final merged field name
	 */
	joinAsFieldName: PropTypes.string,

	/**
	 * The action to perform when the cancel/close button is pressed.
	 */
	onClose: PropTypes.func.isRequired,

	/**
	 * The action to perform when the OK button is pressed. The values are
	 * passed to the function.
	 * {
	 *   parentModel,
	 *   parentField,
	 *   joinType,
	 *   joinModel,
	 *   joinField,
	 *   joinAs,
	 *   joinAsFieldName
	 * }
	 */
	onOkay: PropTypes.func.isRequired,

	/**
	 * The text for the OK button.
	 */
	okayText: PropTypes.string,

	/**
	 * The text for the Close/Cancel button.
	 */
	closeText: PropTypes.string
};

JoinInfoDialog.defaultProps = {
};

export default injectIntl(JoinInfoDialog);
